$( document ).ready(function() {
  $(".search-filter-options").on("click", function (e) {
    $('.filter-container').toggleClass("hidden");
    $('.search-filter-options').toggleClass("hidden");
  });
})
